import cargoCompanyOrderBillingsDownloadRequest, {
  CargoCompanyOrderBillingsDownloadQueryParams,
} from "./cargo-company-order-billings-download.request";

const createQueryParams = (
  request: cargoCompanyOrderBillingsDownloadRequest,
): CargoCompanyOrderBillingsDownloadQueryParams => {
  return {
    address: request.address,
    date_since: request.date_since,
    date_to: request.date_to,
    dispatch: request.dispatch,
    end_address: request.end_address,
    external_id: request.external_id,
    human_id: request.human_id,
    mid_address: request.mid_address,
    order: request.order,
    passenger: request.passenger,
    start_address: request.start_address,
    status: request.status,
    taxi: request.taxi,
  };
};

const cargoCompanyOrderBillingsDownloadRequestFactory = {
  createQueryParams,
};

export default cargoCompanyOrderBillingsDownloadRequestFactory;
